import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { productSlider } from '../../constants/data';
import SlideUp from "../ui/SlideUp";
import settings from "../../constants/settings";
import {Link} from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const Product = () => {
  const sectionRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const { t } = useTranslation();
  // Detect RTL direction
  const isRTL = document.dir === 'rtl';

  useEffect(() => {
    const section = sectionRef.current;
    const scrollContainer = scrollContainerRef.current;

    const totalScrollWidth = scrollContainer.scrollWidth;
    const visibleWidth = section.offsetWidth;
    const scrollDistance = totalScrollWidth - visibleWidth;
    const topPaddingOffset = window.innerWidth >= 768 ? '27%' : '15%';

    let ctx = gsap.context(() => {
      gsap.to(scrollContainer, {
        x: isRTL ? scrollDistance : -scrollDistance, // <- Adjust direction
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: `top ${topPaddingOffset}`,
          end: () => `+=${scrollDistance}`,
          pin: true,
          scrub: 1,
          anticipatePin: 1,
        },
      });
    }, section);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="relative overflow-hidden w-full bg-whitee">
      <div className="md:w-theme-container w-mobile-container mx-auto">
        <SlideUp>
          <h3 className="text-left text-2xl">{t('common.products')}</h3>
          <div className="text-left text-base">{t('common.weHaveLunched')}</div>
        </SlideUp>
      </div>
      <div
        ref={scrollContainerRef}
        className="flex md:space-x-12 space-x-5 py-10 w-max"
      >
        {productSlider.map((product, index) => (
          <div
            key={product.id}
            // className={`relative min-w-[300px] h-[450px] ${product.id === 1 && 'md:ml-[40%] ml-[0.5%]'}
            // `}
            className={`relative min-w-[300px] h-[450px] ${
              product.id === 1
                ? isRTL
                  ? 'md:mr-[6%] ml-[2%]'
                  : 'lg:ml-[6.3%] md:ml-[4.5%] ml-[0.5%]'
                : ''
            }`}
          >
            {/* Flip card container */}
            <div className="flip-card w-full h-full">
              <div className="flip-card-inner">
                {/* Front side */}
                <div className="flip-card-front bg-gray-200 rounded-lg overflow-hidden w-full h-full flex items-center justify-center shadow-md">
                  {!product.imgName ? (
                    <div className="text-xl p-4 text-center">{product.name}</div>
                  ) : (
                    <img
                      src={require(`../../assets/images/products/${product.imgName}`)}
                      alt={product.name}
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
                {/* Back side */}
                <div className={`
                    flip-card-back bg-gradient-to-bl from-blue-200 to-blue-100 rounded-lg overflow-hidden w-full h-full flex flex-col p-3 shadow-lg border border-gray-100
                  `}>
                  <div className="flex-1 flex flex-col items-center justify-start">
                    {/* Product Title */}
                    <h3 className="text-xl mt-5 mb-12 text-center text-gray-800">
                      {t(`productSliders.titles.${index}`)}
                    </h3>
                    {/* Description with better typography */}
                    <p className="text-gray-600 text-center leading-relaxed mb-6 max-w-[90%]">
                      {t(`productSliders.descriptions.${index}`) || 'Discover the features and benefits of this product'}
                    </p>
                  </div>
                  {/* Call-to-action button */}
                  <Link
                    // href={product.link === '' ? settings.domain : settings.domain+product.link}
                    to={product.link === '' ? settings.domain : settings.domain+product.link}
                    className="mt-auto w-full max-w-[160px] mx-auto px-6 py-2 bg-gradient-to-r from-blue-300 to-theme-color text-white font-medium rounded-lg hover:from-blue-600 hover:to-theme-color transition-all duration-300 shadow-sm hover:shadow-md text-center"
                  >
                    {t(`common.readMore`)}
                    <svg className="w-4 h-4 ml-2 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className="w-[0.5%] md:min-w-[8.2%]" />
      </div>
    </section>
  );
};

export default Product;
